import React from 'react';
import ContentLabRoutes from './contentlab';

export interface MainRoute {
  name: string;
  path: string;
  Component: React.ComponentType<{flags: any}>;
}

const contentLabRoutesList = [
  {
    name: 'content-lab',
    path: `/*`,
    Component: ContentLabRoutes,
  },
];

export default contentLabRoutesList;
